export const transportRouteDefinitions = [
  {
    path: 'transport',
    requiredPermission: 'transport.view',
    exportName: 'TransportListPage',
    load: () => import('./pages/TransportListPage'),
  },
  {
    path: 'transport/:id',
    requiredPermission: 'transport.view',
    exportName: 'TransportDetailPage',
    load: () => import('./pages/TransportDetailPage'),
  },
] as const;
